import { BASE_URL_API } from '@constants/base';
import { get } from '@utils/ajax';

/**
 * Postal Code Service
 * Handles all postal code related API calls
 */
const postalCodeService = (() => {
    // Search postal codes
    const searchPostalCodes = async params => {
        try {
            const response = await get(
                `${BASE_URL_API}/main/postcode/search.php`,
                {
                    method: 'search',
                    ...params
                },
                {
                    showError: true
                }
            );
            return response;
        } catch (error) {
            return error;
        }
    };

    // Get postal code detail (address information)
    const getPostalCodeDetail = async postalCode => {
        try {
            const response = await get(
                `${BASE_URL_API}/main/postcode/detail.php`,
                {
                    method: 'detail',
                    search_term: postalCode
                },
                {
                    showError: false
                }
            );
            return response;
        } catch (error) {
            return error;
        }
    };

    return {
        searchPostalCodes,
        getPostalCodeDetail
    };
})();

export default postalCodeService;
